import * as z from "zod";

export const SpellCheckImageError = z.object({
  text: z.string(),
  suggestion: z.string().optional(),
});

export type SpellCheckImageError = z.infer<typeof SpellCheckImageError>;
